const TOOLBAR_DROPDOWN_PANEL = "toolbars-modal-desktop-panel";
export {
  TOOLBAR_DROPDOWN_PANEL
};
//# sourceMappingURL=data-hooks.js.map
